import { timestampDTOSchema } from '@tempo-io/common-dto';
import { z } from 'zod';
import { insightKindSchema, insightStatusSchema, insightValenceSchema } from './enums';

export const insightMetadataSchema = z
  .object({
    source: z.string().optional(),
  })
  .catchall(z.unknown())
  .nullable();
export type InsightMetadata = z.infer<typeof insightMetadataSchema>;

export const insightDTOSchema = z.object({
  id: z.string(),
  organizationId: z.string(),
  title: z.string(),
  description: z.string(),
  status: insightStatusSchema,
  valence: insightValenceSchema,
  kind: insightKindSchema,
  confidence: z.string().nullable(),
  modelName: z.string().nullable(),
  metadata: insightMetadataSchema,
  catalogId: z
    .string()
    .nullable()
    .describe(
      'Stable catalog id for the finding (e.g. I-2); persists for the life of the finding, so it outlives the row id, which is retired when the finding resolves.',
    ),
  scopeKey: z
    .string()
    .describe(
      'What the finding is about, as `<kind>:<id>` (e.g. team:7); empty for an org-level finding.',
    ),
  closedAt: z
    .string()
    .nullable()
    .describe('ISO timestamp at which the insight was closed; null while it is still open'),
  signalInstanceIds: z
    .array(z.string())
    .default([])
    .describe('Backing signal instance ids for this insight, ordered by relevance (highest first)'),
  regeneratedAt: z
    .string()
    .nullable()
    .default(null)
    .describe(
      'ISO timestamp of the last time this insight’s text was rewritten; null if never rewritten since it opened. Its numbers can be newer than this — a refresh re-points evidence without regenerating prose.',
    ),
  ...timestampDTOSchema.shape,
});
export type InsightDTO = z.infer<typeof insightDTOSchema>;
